import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { Grid, Button, Switch } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import DoctariCalendar from '../../components/DoctariCalendar';
import LinearLoader from '../../components/LinearLoader';
import Notification from '../../components/Notification';
import { AGENDA } from '../../utils/urls';
import MyAppointments from './MyAppointments';
import GuardCardItem from './GuardCardItem';
import GuardCard from './GuardCard';

function Doctor({
  doctor,
  classes,
  doctorsInfo,
  appointmentsData,
  deleteMessages,
  getDoctorsInfo,
  createScheduleRequests,
  getScheduleRequests,
  getSchedulesByDate,
  getAppointments,
  clearAppointments,
  getNewAccessToken,
  userState,
  getRapidQueues,
}) {
  const theme = useTheme();
  const history = useHistory();

  const [state, setState] = useState({
    dateOfAppointment: null,
    doctorName: null,
    specialty: null,
    country: null,
    type: null,
    availability: true,
    score: false,
  });
  const {
    dateOfAppointment,
    doctorName,
    specialty,
    country,
    type,
    availability,
    score,
  } = state;
  const { countries, specialities, numOfPages, doctors, currentPage } =
    doctorsInfo;
  const [appointmentLoading, setAppointmentLoading] = useState(true);

  const [switchTest, setSwitchTest] = useState(true);
  const handleSwitchChange = (event) => {
    setSwitchTest(event.target.checked);
  };
  const [openGuardCard, setOpenGuardCard] = useState(true);
  const toogleGuardCard = () => {
    setOpenGuardCard(!openGuardCard);
  };

  useEffect(() => {
    if (doctor && doctor.id) {
      //   getDoctorsInfo([], [], currentPage, doctor.accessToken);
      getScheduleRequests(`?doctor=${doctor.id}`, doctor.accessToken);
      getSchedulesByDate(
        moment()
          .day(1)
          .set('hour', '00')
          .set('minute', '00')
          .add(0, 'days')
          .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
          .format('YYYY-MM-DD HH:mm'),
        moment()
          .day(1)
          .add(7, 'days')
          .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
          .format('YYYY-MM-DD HH:mm'),
        doctor.id
      );
    }
    getRapidQueues();
  }, []);

  useEffect(() => {
    if (doctor && doctor.id) {
      let queryParams = ['date__gt', 'is_cancelled'];
      let queryValues = [
        moment()
          .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
          .subtract(30, 'minutes')
          .format('YYYY-MM-DD HH:mm'), // convert to UTC-3 time
        false,
      ];

      getAppointments(
        'doctor',
        doctor.id,
        false, //isDone
        true, //isPayed
        queryParams,
        queryValues
      );
    }
    return () => clearAppointments();
  }, []);

  useEffect(() => {
    if (
      appointmentsData.appointments &&
      appointmentsData.appointments.length >= 0
    ) {
      setAppointmentLoading(false);
    }
  }, [appointmentsData.appointments]);

  return (
    <>
      {doctorsInfo.loading && <LinearLoader />}
      {/* {appointmentsData.success && (
        <Notification
          type='success'
          message={'Consulta creada exitosamente'}
          onCloseCallback={deleteMessages}
        />
      )}
      {appointmentsData.error && (
        <Notification
          type='error'
          message={'No se pudo crear la solicitud, intentelo de nuevo'}
          onCloseCallback={deleteMessages}
        />
      )} */}
      {appointmentsData.success.genericMessage ==
        'Appointment eliminado con exito' && (
        <Notification
          type='error'
          message={'Consulta cancelada'}
          onCloseCallback={deleteMessages}
        />
      )}
      <Grid
        container
        direction='column'
        alignItems='center'
        style={{ flexWrap: 'initial', fontFamily: theme.typography.fontFamily }}
      >
        <MyAppointments
          appointmentData={appointmentsData}
          theme={theme}
          isProfessional={true}
          classes={classes}
          session={doctor}
          getNewAccessToken={getNewAccessToken}
          userState={userState}
          appointmentLoading={appointmentLoading}
        ></MyAppointments>
        <GuardCard
          openGuardCard={openGuardCard}
          classes={classes}
          switchTest={switchTest}
          handleSwitchChange={handleSwitchChange}
          handleOpenClose={toogleGuardCard}
        />
        <Grid item xs={11} md={12}>
          <h1
            className={classes.title}
            style={{ fontSize: '40px', textAlign: 'center' }}
          >
            Mi agenda
          </h1>
          <DoctariCalendar
            currentWeek={0}
            schedules={appointmentsData.schedules}
            slot={doctor.slot}
          >
            <Button
              variant='contained'
              color='primary'
              style={{ width: '206px' }}
              onClick={() => history.push(AGENDA)}
            >
              {'Editar calendario'}
            </Button>
          </DoctariCalendar>
        </Grid>
      </Grid>
    </>
  );
}

export default Doctor;
